import { Image, View } from "@aws-amplify/ui-react";
import { useMediaQuery } from "@mui/material";
import { images } from "constants/index";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { originSlide } from "constants/index";
import { Navigation } from "swiper/modules";

export default function OriginStory() {
  const matches = useMediaQuery("(min-width:1100px)");

  return (
    <View
      className={`relative flex flex-col w-[100vw] ${
        matches ? "px-20 " : "px-5"
      } pb-10`}
    >
      {/* <View className="absolute mt-[-30px] w-[280px] z-30 ">
        <Image
          // display={mobilematches ? "" : "none"}
          src="/EHRLogo.png"
          alt="about logo"
          width="200px"
          height="300px"
          objectFit="cover"
          position="relative"
        />
      </View> */}
      <View className="relative flex justify-end ">
        <div className="font-bold text-[66px] text-white z-10 font-lolita-one">
          Origin Story
        </div>
      </View>
      <View
        className={`relative flex mt-[-22px] ${matches ? "" : "flex-col"} `}
      >
        <View className="relative flex flex-row gap-3">
          <Image
            width={matches ? 1200 : ""}
            height={matches ? 700 : ""}
            objectFit="cover"
            alt="origin story"
            src={images.sk21}
          />
        </View>
        <Swiper
          modules={[Autoplay, Navigation]}
          loop={true}
          autoplay={{
            delay: 5500,
          }}
          pagination={{ clickable: true }}
          navigation
          className="relative flex    justify-self-end w-[100%] bg-[rgba(0,0,0,.8)]"
        >
          {originSlide.map((item, index) => (
            <SwiperSlide className="relative" key={index}>
              <div className=" text-[20px] font-medium text-white px-14 py-10 font-lolita-one">
                {item}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </View>
    </View>
  );
}
